// Imports
import currency from 'currency.js';
import planMapping from '../billing/plan-mapping';
import subscriptionAmountMapping from './subscription-amount-mapping';


/** Shareable to determine monthly cost of a subscription at a given size */
export default function determineMonthlySubscriptionAmount(options: {
	plan: (typeof planMapping)[keyof typeof planMapping];
	size: number;
	yearly: boolean;
}) {
	// Free plan is always free
	if (options.plan === 0) {
		return currency(0);
	}
	
	
	// Retrieve plan
	const plan = subscriptionAmountMapping[planMapping.deluxe];
	
	
	// Find matching subscription mapping from size
	const subscriptionAmount = Object.entries(plan).find(([size]) => parseInt(size) >= options.size);
	
	if (!subscriptionAmount) {
		throw new Error('Plan does not support this size');
	}
	
	
	// Retrieve subscription amount
	const [, amount] = subscriptionAmount;
	
	
	// Return discounted amount
	return currency(amount).multiply(options.yearly ? 0.9 : 1);
}
